module.exports = __webpack_public_path__ + "img/compas.ca713a08.svg";